import { put } from "redux-saga/effects";
import { logoutUser } from "actions/userActions";
import AppsmithConsole from "utils/AppsmithConsole";
import type { TLogoutDescription } from "workers/Evaluation/fns/logout";

export function* logoutActionSaga(action: TLogoutDescription) {
  yield put(logoutUser());
  AppsmithConsole.info({ text: `logout()`, source: action as any });
}
